import CreateValueModule from "@/redux/create-value-module";

import { $VatInfoModuleName, TVatInfoState } from "./vatInfo.types";

const { actions } = CreateValueModule<TVatInfoState>($VatInfoModuleName, {
    data: null,
    isLoading: false
});

export const set = actions.set;
export const update = actions.update;
